import { ErrorBoundary } from 'next/dist/client/components/error-boundary';
import SearchBoxModal from '@/modules/search-box-modal';
import { isAviosOpco } from '@/utils/opco-utils';
import { MainProperties } from './main.types';
import headerStyles from '../header/header.module.scss';
import GenericErrorSection from '../generic-error-section';

export const hasEnabledSearchSection = (object: unknown): boolean => {
  if (typeof object !== 'object' || object === null) return false;

  return Object.values(object).some(
    key => key?.heroSection?.enableSearch ?? key?.searchSection?.enableSearch,
  );
};

const getShowSmallSearchFromSecondLevel = (
  object: Record<string, unknown>,
): boolean | undefined => {
  if (typeof object !== 'object' || object === null) return false;

  for (const key in object) {
    if (
      typeof object[key] === 'object' &&
      object[key] !== null && // Check if showSmallSearch exists at this second level
      'showSmallSearch' in object[key]
    ) {
      return !!object[key].showSmallSearch;
    }
  }
  return true; // Default to true if not found
};

export const Main = ({
  skeletonHeader,
  opcoId,
  ...mainProperties
}: MainProperties) => (
  <main>
    <ErrorBoundary errorComponent={GenericErrorSection}>
      {skeletonHeader && (
        <div
          data-testid="skeleton-header"
          className={headerStyles['avios-header']}
        />
      )}
      {'pageProps' in mainProperties ? (
        <>
          {opcoId &&
            isAviosOpco(opcoId) &&
            getShowSmallSearchFromSecondLevel(mainProperties.pageProps) &&
            !hasEnabledSearchSection(mainProperties.pageProps) && (
              <SearchBoxModal />
            )}
          <mainProperties.Component {...mainProperties.pageProps} />
        </>
      ) : (
        mainProperties.children
      )}
    </ErrorBoundary>
  </main>
);
